import { ICreateGedDocumentoUseCase } from "../../../presentation/useCases/create/create_ged_documento_use_case";
import { UserFriendlyError } from "../../../utils/base_error";
import { TelasIds } from "../../../utils/tela_ids";
import { ICommonsRepository } from "../../repositories/commons_repository";

export class CreateGedDocumentoUseCase implements ICreateGedDocumentoUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async createGedDocumento(
    idTela: TelasIds,
    idModuloDocumento: number,
    arquivo: string,
    observacoes: string | null,
    file: File | null,
    filePdf: File | null,
  ): Promise<void> {
    const arquivoNomePdf = await this.getFilename(filePdf);

    const pdfExtension = arquivoNomePdf !== null
      ? arquivoNomePdf.split('.').pop()
      : null;

    if (pdfExtension !== null && pdfExtension !== undefined && pdfExtension.toLowerCase() !== 'pdf') {
      throw new UserFriendlyError("O arquivo PDF deve ter a extensão .pdf");
    }

    await this.repository.createGedDocumento(
      idTela,
      idModuloDocumento,
      null,
      null,
      arquivo,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      observacoes,
      null,
      null,
      null,
      null,
      null,
      null,
      file === null ? null : file,
      filePdf === null ? null : filePdf,
      null,
    );
  }

  async createGedDocumentoInterno(
    idTela: TelasIds,
    idModuloDocumento: number,
    statusArquivo: number,
    tipo: number,
    arquivo: string,
    versao: string | null,
    centroCusto: number | null,
    revisadoPor: number | null,
    aprovadoPor: number | null,
    responsavelProcesso: number | null,
    localArmazenamento1: string | null,
    localArmazenamento2: string | null,
    acesso: string | null,
    recuperacao: string | null,
    protecao: string | null,
    retencao: string | null,
    disposicao: string | null,
    observacoes: string | null,
    file: File | null,
    filePdf: File | null,
    revisao: number | null
  ): Promise<void> {
    const arquivoNomePdf = await this.getFilename(filePdf);

    const pdfExtension = arquivoNomePdf !== null
      ? arquivoNomePdf.split('.').pop()
      : null;

    if (pdfExtension !== null && pdfExtension !== undefined && pdfExtension.toLowerCase() !== 'pdf') {
      throw new UserFriendlyError("O arquivo PDF deve ter a extensão .pdf");
    }

    await this.repository.createGedDocumento(
      idTela,
      idModuloDocumento,
      statusArquivo,
      tipo,
      arquivo,
      versao,
      centroCusto,
      revisadoPor,
      aprovadoPor,
      responsavelProcesso,
      localArmazenamento1,
      localArmazenamento2,
      acesso,
      recuperacao,
      protecao,
      retencao,
      disposicao,
      observacoes,
      null,
      null,
      null,
      null,
      null,
      null,
      file === null ? null : file,
      filePdf === null ? null : filePdf,
      revisao,
    );
  }

  async createGedDocumentoExterno(
    idTela: TelasIds,
    idModuloDocumento: number,
    statusArquivo: number,
    arquivo: string,
    versao: string | null,
    centroCusto: number | null,
    local1: string | null,
    local2: string | null,
    assunto: string | null,
    conferirAtualizacao: Date | null,
    ondeConsultar: string | null,
    dataVencimento: Date | null,
    dataPublicacao: Date | null,
    dataVigencia: Date | null,
    file: File | null,
    filePdf: File | null,
  ): Promise<void> {
    const arquivoNomePdf = await this.getFilename(filePdf);

    const pdfExtension = arquivoNomePdf !== null
      ? arquivoNomePdf.split('.').pop()
      : null;

    if (pdfExtension !== null && pdfExtension !== undefined && pdfExtension.toLowerCase() !== 'pdf') {
      throw new UserFriendlyError("O arquivo PDF deve ter a extensão .pdf");
    }

    await this.repository.createGedDocumento(
      idTela,
      idModuloDocumento,
      statusArquivo,
      null,
      arquivo,
      versao,
      centroCusto,
      null,
      null,
      null,
      local1,
      local2,
      null,
      null,
      null,
      null,
      null,
      null,
      assunto,
      conferirAtualizacao,
      ondeConsultar,
      dataVencimento,
      dataPublicacao,
      dataVigencia,
      file === null ? null : file,
      filePdf === null ? null : filePdf,
      null,
    );
  }

  private async getFilename(file: File | null): Promise<string | null> {
    if (file === null) return null;
    return file.name;
  }
}
